<template>
    <div>
       <pages-form 
            :is-pages-form-sidebar-active.sync="isPagesFormSidebarActive"
            :pages-data="pagesData"
            :pages-list="pages"
            @refetch-data="refetchData" 
       />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                            variant="primary"
                            @click="updateData()"
                            >
                                <span class="text-nowrap">Add Pages</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!pages.length"
                :items="pages"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
            <thead>
                <tr>
                <th scope="col" v-for="col in tableColumns">
                    {{col.label}}
                </th>
                </tr>
            </thead>
            <draggable v-model="pages" tag="tbody" handle=".handle" @change="updatePageOrdering()">
                <tr v-for="(item, index) in pages" :key="index" >
                    <th scope="row" class="pl-2" >
                        <MenuIcon icon="MenuIcon" class="handle"/> 
                    </th>
                    <td class="pl-2">
                        <span>{{item.title[currentLocale]}}</span>
                    </td>
                    <td class="pl-2">
                        <span>{{item.slug[currentLocale]}}</span>
                    </td>
                    <td class="pl-2">
                        <b-badge
                        pill
                        :variant="`light-${resolveCatStatusVariant(item.is_active)}`"
                        class="text-capitalize"
                    >
                        {{ resolveCatStatusnameVariant(item.is_active) }} 
                    </b-badge>
                    </td>
                    <td class="pl-2">
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateData(item)" variant="outline-success">Edit</b-button>
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                    </td>
                </tr>
            </draggable>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalPages"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
      BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
      BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    //api
    import axios from '@axios'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import usePagesList from './usePagesList'
    import pagesStoreModule from '../pagesStoreModule'
    import PagesForm  from '../pages-form/PagesForm.vue'
    import {  MenuIcon } from 'vue-feather-icons'
    import draggable from 'vuedraggable'

    import vSelect from 'vue-select'
    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
            BImg,
            PagesForm,
            vSelect,
            draggable,
            MenuIcon
        },
        directives:{
            'b-modal': VBModal,
            Ripple
    
        },
        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },
        setup(){
            const PAGES_STORE_MODULE_NAME = 'app-pages';
            if (!store.hasModule(PAGES_STORE_MODULE_NAME)) store.registerModule(PAGES_STORE_MODULE_NAME, pagesStoreModule)
            onUnmounted(() => {
                if (store.hasModule(PAGES_STORE_MODULE_NAME)) store.unregisterModule(PAGES_STORE_MODULE_NAME)
            });
            const {
                pagesData,
                isPagesFormSidebarActive,
                refCatListTable,
                tableColumns,
                perPage,
                totalPages,
                currentPage,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                statusFilter,
                dataMeta,
                refetchData,
                fetchData,
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                updateData,
                deleteData,
                updatePageOrdering,
                pages
            } = usePagesList();

            fetchData()

            return {
                pagesData,
                isPagesFormSidebarActive,
                refCatListTable,
                tableColumns,
                perPage,
                totalPages,
                currentPage,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                statusFilter,
                dataMeta,
                refetchData,
                fetchData,
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                updateData,
                deleteData,
                updatePageOrdering,
                pages
            }
    
    
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Page ID.'+id, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                    if(value === true){
                    this.deleteData(id)
                    }
                
                    //this.deleteData(id)
                    })
    
            },
        }
    }
    
    </script>
    